


























































































import { Component, Vue } from 'vue-property-decorator';
import BluetoothManager from '@/lib/bluetoothManager';
import { ArrayPropsDefinition } from 'vue/types/options';
// import BluetoothButton from '../components/BluetoothButton';

@Component({})
export default class Devices extends Vue {
  private bluetoothManager: BluetoothManager;
  private dialog: boolean = false;
  private connectionStatus: boolean = false;
  private connectionStatusMessage: string = 'Connecting...';

  private items: Array<{icon: string, title: string, subtitle: string}> = [];
  private locations: string[];

  public constructor() {
    super();
    this.bluetoothManager = new BluetoothManager(this.$store);
    this.bluetoothManager.on('connected', this.deviceConnected);
    this.bluetoothManager.on('error', (message: string) => {
      this.connectionStatusMessage = message;
    });
    this.locations = this.$store.getters.settings.locations;
  }
  // private beforeRouteLeave(to: any, from: any, next: any) {}

  private connect(label: string) {
    this.dialog = false;
    this.connectionStatus = true;
    this.bluetoothManager.addDevice(label);
    // this.$store.commit('addSensor', label );
  }

  private deviceConnected(device: BluetoothDevice, label: string) {
      this.items.push({
        icon: 'bluetooth',
        title: label,
        subtitle: `${device.name} - ${device.uuids}`,
      });
      this.connectionStatus = false;
    }
}
